import React from 'react';

interface IWhatsappContactLinkProps {
	className?: string;
	children: React.ReactNode;
}

const WhatsappContactLink = (props: IWhatsappContactLinkProps) => {
	const { className, children } = props;

	return (
		<a href={'https://wa.me/5548992168045'} target={'_blank'} rel="noreferrer" className={className}>
			{children}
		</a>
	);
};

export default WhatsappContactLink;
